export default __webpack_public_path__ + "static/media/turtle.086cf65a.jpg";